import VueApp from "../../03-fragments/vueApp/VueApp.js";

const processor = function(data) {
    return data;
}

const callback = function() {
    const target = document.querySelector("html");

    if (target.dataset.vueApps && parseInt(target.dataset.vueApps) > 0) {
        target.dataset.vueApps = target.dataset.vueApps - 1;
    }
}

VueApp.init({
    id: "timelineSection",
    processor: processor,
    callback: callback,
    settings: {
        customType: "blog-story",
        root: "/fortschritt",
        batchCount: 5,
    },
    data: {
    },
});
